export default "__VITE_ASSET__HtuXVjM0__"